var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1486 39.0984C48.4658 39.4554 47.7617 39.7701 47.0402 40.0405C44.7436 40.8999 42.3108 41.3376 39.8587 41.3328C30.3928 41.3328 22.1471 34.8215 22.1471 26.4658C22.1593 25.3451 22.4703 24.2479 23.048 23.2876C23.6258 22.3272 24.4494 21.5384 25.4338 21.0027C16.8721 21.3628 14.6716 30.2846 14.6716 35.5116C14.6716 50.2906 28.2924 51.7889 31.227 51.7889C32.8093 51.7889 35.1958 51.3288 36.6281 50.8767L36.8901 50.7887C42.4017 48.8833 47.1004 45.1582 50.2128 40.2266C50.3082 40.0764 50.3507 39.8987 50.3338 39.7216C50.3168 39.5445 50.2414 39.3782 50.1193 39.2487C49.9973 39.1193 49.8356 39.0343 49.6598 39.0071C49.484 38.9798 49.3041 39.0119 49.1486 39.0984Z",
    fill: "url(#paint0_linear_116_14502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M49.1486 39.0984C48.4658 39.4554 47.7617 39.7701 47.0402 40.0405C44.7436 40.8999 42.3108 41.3376 39.8587 41.3328C30.3928 41.3328 22.1471 34.8215 22.1471 26.4658C22.1593 25.3451 22.4703 24.2479 23.048 23.2876C23.6258 22.3272 24.4494 21.5384 25.4338 21.0027C16.8721 21.3628 14.6716 30.2846 14.6716 35.5116C14.6716 50.2906 28.2924 51.7889 31.227 51.7889C32.8093 51.7889 35.1958 51.3288 36.6281 50.8767L36.8901 50.7887C42.4017 48.8833 47.1004 45.1582 50.2128 40.2266C50.3082 40.0764 50.3507 39.8987 50.3338 39.7216C50.3168 39.5445 50.2414 39.3782 50.1193 39.2487C49.9973 39.1193 49.8356 39.0343 49.6598 39.0071C49.484 38.9798 49.3041 39.0119 49.1486 39.0984Z",
    fill: "url(#paint1_radial_116_14502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0756 49.2764C22.2914 48.169 20.7451 46.7179 19.5267 45.0075C18.138 43.1049 17.1824 40.9215 16.7268 38.6104C16.2713 36.2994 16.3269 33.9166 16.8898 31.6294C17.4527 29.3421 18.5091 27.2056 19.9851 25.3699C21.4611 23.5341 23.3208 22.0435 25.4339 21.0027C26.058 20.7086 27.1242 20.1765 28.5425 20.2025C29.5417 20.2098 30.5257 20.4483 31.4173 20.8995C32.3089 21.3507 33.0839 22.0022 33.6816 22.803C34.4894 23.8816 34.9348 25.1884 34.9538 26.5358C34.9538 26.4938 39.8468 10.6125 18.9506 10.6125C10.1688 10.6125 2.94733 18.9462 2.94733 26.2577C2.91269 30.1254 3.74024 33.9522 5.36982 37.46C8.03302 43.1423 12.6902 47.6487 18.4571 50.1235C24.2239 52.5984 30.6988 52.8692 36.6522 50.8847C34.5676 51.5419 32.3654 51.7392 30.1972 51.4629C28.0291 51.1867 25.9467 50.4434 24.0936 49.2844L24.0756 49.2764Z",
    fill: "url(#paint2_linear_116_14502)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M24.0756 49.2764C22.2914 48.169 20.7451 46.7179 19.5267 45.0075C18.138 43.1049 17.1824 40.9215 16.7268 38.6104C16.2713 36.2994 16.3269 33.9166 16.8898 31.6294C17.4527 29.3421 18.5091 27.2056 19.9851 25.3699C21.4611 23.5341 23.3208 22.0435 25.4339 21.0027C26.058 20.7086 27.1242 20.1765 28.5425 20.2025C29.5417 20.2098 30.5257 20.4483 31.4173 20.8995C32.3089 21.3507 33.0839 22.0022 33.6816 22.803C34.4894 23.8816 34.9348 25.1884 34.9538 26.5358C34.9538 26.4938 39.8468 10.6125 18.9506 10.6125C10.1688 10.6125 2.94733 18.9462 2.94733 26.2577C2.91269 30.1254 3.74024 33.9522 5.36982 37.46C8.03302 43.1423 12.6902 47.6487 18.4571 50.1235C24.2239 52.5984 30.6988 52.8692 36.6522 50.8847C34.5676 51.5419 32.3654 51.7392 30.1972 51.4629C28.0291 51.1867 25.9467 50.4434 24.0936 49.2844L24.0756 49.2764Z",
    fill: "url(#paint3_radial_116_14502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3975 30.7607C33.2354 30.9707 32.7373 31.2608 32.7373 31.8929C32.7373 32.415 33.0774 32.9171 33.6815 33.3392C36.5581 35.3396 41.9812 35.0756 41.9952 35.0756C44.1267 35.0705 46.2178 34.4936 48.0504 33.4052C49.8992 32.3257 51.4336 30.7816 52.5014 28.926C53.5692 27.0705 54.1333 24.968 54.1377 22.8271C54.1897 18.3442 52.5373 15.3636 51.8692 14.0433C47.6303 5.75163 38.4805 0.982666 28.5305 0.982666C21.8015 0.982001 15.3427 3.6302 10.551 8.3545C5.75932 13.0788 3.01992 19.4995 2.92529 26.2278C3.02131 18.9183 10.2868 13.0151 18.9285 13.0151C19.6287 13.0151 23.6215 13.0831 27.3302 15.0295C30.5989 16.7459 32.3112 18.8183 33.5015 20.8727C34.7377 23.0071 34.9578 25.7037 34.9578 26.7779C34.9578 27.8521 34.4097 29.4444 33.3975 30.7607Z",
    fill: "url(#paint4_radial_116_14502)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3975 30.7607C33.2354 30.9707 32.7373 31.2608 32.7373 31.8929C32.7373 32.415 33.0774 32.9171 33.6815 33.3392C36.5581 35.3396 41.9812 35.0756 41.9952 35.0756C44.1267 35.0705 46.2178 34.4936 48.0504 33.4052C49.8992 32.3257 51.4336 30.7816 52.5014 28.926C53.5692 27.0705 54.1333 24.968 54.1377 22.8271C54.1897 18.3442 52.5373 15.3636 51.8692 14.0433C47.6303 5.75163 38.4805 0.982666 28.5305 0.982666C21.8015 0.982001 15.3427 3.6302 10.551 8.3545C5.75932 13.0788 3.01992 19.4995 2.92529 26.2278C3.02131 18.9183 10.2868 13.0151 18.9285 13.0151C19.6287 13.0151 23.6215 13.0831 27.3302 15.0295C30.5989 16.7459 32.3112 18.8183 33.5015 20.8727C34.7377 23.0071 34.9578 25.7037 34.9578 26.7779C34.9578 27.8521 34.4097 29.4444 33.3975 30.7607Z",
    fill: "url(#paint5_radial_116_14502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_14502",
    x1: 14.6716,
    y1: 36.3998,
    x2: 50.3469,
    y2: 36.3998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_116_14502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3756 36.681) scale(19.0799 18.1259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_14502",
    x1: 33.4795,
    y1: 20.9246,
    x2: 11.197,
    y2: 45.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_116_14502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0471 40.7923) rotate(-81.3844) scale(28.691 23.1795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_116_14502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.09884 10.4599) rotate(92.2906) scale(40.5266 86.3132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_116_14502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9495 16.467) rotate(73.7398) scale(19.4719 15.8346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.c930d2635b9228d9726cad0e23cbe911.svg";
export { ForwardRef as ReactComponent };